import { ReactNode } from "react";
import { HStack } from "components/Stack";
import Action from "components/formElements/Action/Action";
import { ReactComponent as ArrowDown } from "images/chevron-down.svg";
import { ReactComponent as ArrowUp } from "images/chevron_up.svg";
import { useTranslation } from "react-i18next";

type Props = {
  onClick: () => void;
  expanded: boolean;
  children: ReactNode;
};

function ExpandableWhatIncludedButton(props: Props) {
  const { t } = useTranslation();
  return (
    <>
      <div className={"all-included-row"} onClick={props.onClick}>
        <HStack align={"center"}>
          <Action className={"all-included btn"}>
            {t("Common.See what's included")}
          </Action>
          {props.expanded ? <ArrowUp /> : <ArrowDown />}
        </HStack>
      </div>

      {props.expanded && props.children}
    </>
  );
}

export default ExpandableWhatIncludedButton;
